module.exports = __webpack_public_path__ + "img/muse-bg.bb996ed2.jpg";